import React from 'react';

import fetch from '../fetch';


import utils from './../../utils';

import {Modal, message} from 'antd';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const DataGrid = {
    selections: [],
    data: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'subitemName', 
        width: 100, 
        label: '依据名称',
        render: (data, columns) => {
            return (
                <div style={{whiteSpace: 'pre-line', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: `${columns.optionList.length}`, WebkitBoxOrient: 'vertical'}}>
                    {data}
                </div>
            )
        }
    },
    {
        key:'optionList', 
        label: '依据选项',
        width: 300,
        render: (data, columns) => {
            if(data && data.length > 0) {
                if(columns.subitemType == 4) {
                    return (
                        <ol className="upper-alpha">
                            {
                                data.map((d,i) => (
                                    d.optionType == 1||d.isRanking == 1?(
                                        <div>
                                            {
                                                d.relationName?
                                                <li>{d.relationName}/{d.optionName} ~ {d.optionValue}</li>
                                                :
                                                <li>{d.optionName} ~ {d.optionValue}</li>
                                            }
                                            <ol className="upper-alpha" style={{marginLeft:20}}> 
                                                {
                                                    d.rankDetailList?(
                                                        d.rankDetailList.map(r =>( 
                                                            r.isRanking?(
                                                                <li>{r.rankName} ~ {r.rankValue}</li>
                                                            ):''
                                                        ))
                                                    ):''
                                                }
                                            </ol>
                                        </div>
                                    ):(
                                        d.rateType == 1?(
                                            <li>{d.optionName} ~ {d.optionValue}分/(单位)</li>
                                        ):(
                                            <li>{d.optionName}</li>
                                        )
                                    )
                                ))
                            }
                        </ol>
                    )
                } else {
                    return (
                        "无"
                    )
                }
            }
            return "无";
        }
    },
    {
        key: 'isNeedFillin',
        label: '是否是必填',
        width: 140,
        render: (data) => {
            if(data == 0) {
                return '非必填';
            } else if(data == 1) {
                return '必填';
            }
        } 
    },
    {
        key: 'subitemType', 
        label: '依据类型', 
        render: (type, columns) => {
            if(type == 1) {
                return '文本'+ (columns.textType == 1?'文本框':'文本域');
            } else if(type == 2) {
                return '数字';
            } else if(type == 3) {
                return '时间';
            } else if(type == 4) {
                return (columns.selectType == 1?'选择框':'下拉框')+(columns.checkType == 1?'/单选':'/多选');
            } else if(type == 5) {
                return '分数';
            } 
        }
    },
    {
        key: 'sortNum',
        label: '排序',
        width: 80
    },
    {
        key: 'subitemDesc',
        label: '备注',
        width: 250,
        render: (data, columns) => {
            return (
                <div style={{whiteSpace: 'pre-line', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: `${columns.optionList.length}`, WebkitBoxOrient: 'vertical'}}>
                    {data}
                </div>
            )
        }
    },
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords) => {
    const id = keywords.targetId
    if(!id) {
        return new Promise(() => {
            const list = (Object.assign({
                result: [].map(item => {
                    return Object.assign({}, item, {
                        height: (item.choices || []).length * 30
                    })
                }),
                selects: [].map(d => ({
                    value: d.id,
                    checked: false,
                    height: (d.choices || []).length * 30
                })),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: [].length ? '' : '暂无数据...'
            }));
            return list; 
        })
    }
    return fetch.post(`zgcp/subitem/list`,keywords = {pageNum: 1, pageSize: 100,subId:`${id}`})
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (Object.assign({
            result: (data.dataList || []).map(item => {
                return Object.assign({}, item, {
                    height: height((item.optionList || []))
                })
            }),
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
                height: height((d.optionList || []))
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }));
        DataGrid.data = list.result;
        return list;
    });
}

const height = ((optionList) => {
    
    var row = optionList.length;
    optionList.map(item => {
        item.isRanking?(
            item.rankDetailList?(
                item.rankDetailList.map(r=>{
                    r.isRanking?(
                        row += 1
                    ):''
                })
            ):''
        ):''
    })
    return row * 30;
});

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('zgcp/subitem/insert', data);
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('zgcp/subitem/update/' + id, data);
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('zgcp/subitem/delete/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method querySearchOptionTree
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchOptionTree = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('zgcp/subitem/option/tree', keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(utils.tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

const getUserSelectData = () => {
    const id = DataGrid.selections[0]
    return DataGrid.data.find(d => d.id === id)
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getOptionNumber = () => {
    return fetch.post('zgcp/subitem/option/getOptionNumber/',{})
    .then(response => {
        return response.payload.data;
    })
}

const getRelationModalShow = () => {
    return fetch.post('zgcp/subitem/option/getRelationModalShow/',{})
    .then(response => {
        return response.payload.data;
    })
}

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};

export default {
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    getSelection,
    getUserSelectData,
    querySearchOptionTree,
    redirect,
    getOptionNumber,
    getRelationModalShow
}